var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"redirect-to-action"},[(_vm.formType === 'VendorWorkOrderAction')?_c('div',[_c('VendorWorkOrderActionForm',{attrs:{"token":_vm.token}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }